module.exports = __webpack_public_path__ + "static/media/Bathroom-Shared.a0756d56.png";